// extracted by mini-css-extract-plugin
module.exports = {"root":"CompactCeil_root_2u1TT","inner":"CompactCeil_inner_3Dqer","item":"CompactCeil_item_3_IUq","title":"CompactCeil_title_3xoAY"};